'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _props3 = require('../props');

var _common = require('../../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Editor = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Editor, _Component);

  function Editor() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Editor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Editor.__proto__ || (0, _getPrototypeOf2.default)(Editor)).call.apply(_ref, [this].concat(args))), _this), _this._selectComponent = function (event) {
      event.stopPropagation();
      var _this$props = _this.props,
          id = _this$props.id,
          selectComponent = _this$props.selectComponent;

      if (typeof selectComponent === 'function') selectComponent(id);
    }, _this._onChangeValue = function (event) {
      var _this$props2 = _this.props,
          changeProperty = _this$props2.changeProperty,
          id = _this$props2.id,
          value = _this$props2.value;

      var newValue = event.target.value;

      if (typeof changeProperty === 'function') changeProperty(id, 'value', newValue, value);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Editor, [{
    key: '_getStyle',
    value: function _getStyle() {
      var additionalProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props = this.props,
          color = _props.color,
          fontSize = _props.fontSize,
          fontFamily = _props.fontFamily,
          fontStyle = _props.fontStyle,
          fontWeight = _props.fontWeight,
          textDecoration = _props.textDecoration,
          padding = _props.padding,
          margin = _props.margin,
          borderStyle = _props.borderStyle,
          borderWidth = _props.borderWidth,
          borderColor = _props.borderColor;


      return (0, _reactcss2.default)({
        default: {
          root: {},
          label: {
            color: color,
            fontSize: fontSize,
            fontFamily: fontFamily,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            textDecoration: textDecoration,
            padding: padding,
            margin: margin,
            borderStyle: borderStyle,
            borderWidth: borderWidth,
            borderColor: borderColor
          }
        }
      }, (0, _extends3.default)({}, this.props, additionalProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          id = _props2.id,
          name = _props2.name,
          label = _props2.label,
          value = _props2.value,
          placeholder = _props2.placeholder,
          isSelected = _props2.isSelected;

      var _id = 'input-text-' + id;
      var style = this._getStyle();
      var styles = require('./Editor.scss');

      return _react2.default.createElement(
        _common.EditorComponentWrapper,
        { isSelected: isSelected },
        _react2.default.createElement(
          'div',
          {
            style: style.root,
            className: (0, _classnames2.default)(className, styles.root),
            onClick: this._selectComponent
          },
          _react2.default.createElement(
            'span',
            {
              id: _id,
              name: name,
              value: value,
              placeholder: placeholder,
              autoFocus: isSelected,
              style: style.label,
              className: styles.label
            },
            '' + label
          )
        )
      );
    }
  }]);
  return Editor;
}(_react.Component), _class.propTypes = _props3.propTypes, _class.defaultProps = (0, _extends3.default)({}, _props3.defaultProps, { padding: '5px' }), _temp2);
exports.default = Editor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Label/Editor/Editor.jsx
// module id = 1541
// module chunks = 0